export default "__VITE_ASSET__uhfck$ZW__"